import CustomerScreenShell from "@/components/customer-screen-shell";
import Notice from "@buildpy/ui/notice";
import { UNUSABLE_LINK_BODY, UNUSABLE_LINK_TITLE } from "@buildpy/core/modules/contract/customer-link-text";

// 없는·회수·만료·파기·해지 링크가 모두 같은 화면이다 — 어느 쪽인지 말하면 토큰의 존재가 새어 나간다.
const UnusableLink = () => (
  <CustomerScreenShell>
    <Notice body={UNUSABLE_LINK_BODY} title={UNUSABLE_LINK_TITLE} />
  </CustomerScreenShell>
);

export default UnusableLink;
